var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallGreenSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 27,
    viewBox: "0 0 2 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.648438 0.675781L0.648436 26.3813",
    stroke: "#26A677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGreenSeparator);
export default __webpack_public_path__ + "static/media/smallGreenSeparator.9c7eb4289e0549f9299fe0e8a6f234e2.svg";
export { ForwardRef as ReactComponent };